module.exports = __webpack_public_path__ + "img/ArgIslan.48b94f1a.jpg";